/**
 * Shared import-row accounting helpers.
 *
 * Both the progress phase and the result phase derive the "imported" (newly created)
 * row count the same way. Keeping the formula in one place prevents the two screens
 * from silently drifting apart — the exact bug fixed in CU-86ca6pvrk/6wb8g, where the
 * accounting diverged and the result screen showed "Imported: 0".
 */

/** Coerces a nullable counter to a number, defaulting null/undefined to 0. */
export function safeCount(n: number | null | undefined): number {
  return n ?? 0;
}

/**
 * Newly created rows = processed - updated.
 *
 * `processedRows` already counts only successful rows (the worker counts a row as
 * processed XOR errored), so errors are already excluded and must NOT be subtracted
 * again. Clamped at 0 to guard against transient out-of-order counter updates.
 */
export function computeImportedRows(processedRows: number, updatedRows: number): number {
  return Math.max(processedRows - updatedRows, 0);
}
